import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cc0013',
    ecrans: ['00-2'],
    params: ['id']
});
